import styled, { css } from "styled-components";

export const StyledSelectWrapper = styled.div`
  width: 100%;
  max-width: 420px;

  .select__control {
    border: 0;
    border-bottom: 2px solid ${({ theme }) => theme.colors.primarySeparator};
    border-radius: 2px;
    box-shadow: none;
    height: 42px;
    background-color: ${({ theme }) => theme.colors.neutralsWhiteTint60};
    transition: background-color 200ms linear;
    position: relative;

    &:hover {
      box-shadow:
        0px 8px 16px 0px rgba(161, 153, 194, 0.2),
        0px 4px 8px 0px rgba(161, 153, 194, 0.16),
        0px 2px 4px 0px rgba(161, 153, 194, 0.12),
        0px 1px 2px 0px rgba(161, 153, 194, 0.08);
      border-bottom: 2px solid ${({ theme }) => theme.colors.primaryTextHover};
    }

    ${({ $error }) =>
      $error &&
      css`
        border-bottom: 2px solid ${({ theme }) => theme.colors.offTrackText} !important;
      `}

    &.select__control--is-focused {
      color: ${({ theme }) => theme.colors.neutralsText};
      border: 0;
      border-bottom: 2px solid;
      border-color: ${({ theme }) => theme.colors.primarySeparator};
      box-shadow: none;
    }

    ${({ $selected }) =>
      $selected &&
      css`
        background-color: ${({ theme }) => theme.colors.primaryTextTint08};
        border-bottom: 2px solid
          ${({ theme }) => theme.colors.primaryBackgroundSelected};
        color: ${({ theme }) => theme.colors.neutralsText};
        &:hover {
          box-shadow:
            0px 8px 16px 0px rgba(161, 153, 194, 0.2),
            0px 4px 8px 0px rgba(161, 153, 194, 0.16),
            0px 2px 4px 0px rgba(161, 153, 194, 0.12),
            0px 1px 2px 0px rgba(161, 153, 194, 0.08);
          border-bottom: 2px solid
            ${({ theme }) => theme.colors.primaryBackgroundSelected};
        }
      `}
  }

  .select__placeholder {
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
  }

  .select__indicator-separator {
    display: none;
  }

  .select__indicators svg {
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .select__multi-value__label {
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
  }

  .select__single-value {
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
    margin-left: 0;
    ${({ $selected }) =>
      $selected &&
      css`
        color: ${({ theme }) => theme.colors.neutralsText};
      `}
  }

  .select__value-container {
    padding: 0 8px;
    padding-top: 12px;
  }

  .select__menu {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-top: 0;
    box-shadow:
      0px 8px 16px 0px rgba(161, 153, 194, 0.2),
      0px 4px 8px 0px rgba(161, 153, 194, 0.16),
      0px 2px 4px 0px rgba(161, 153, 194, 0.12),
      0px 1px 2px 0px rgba(161, 153, 194, 0.08);
    background-color: ${({ theme }) => theme.colors.neutralsWhite};
    z-index: 2;

    .select__menu-list {
      padding: 0;

      .select__option {
        color: ${({ theme }) => theme.colors.neutralsTextLight};
        ${({ theme }) => theme.fontStyles.InterfaceCopy}
        padding: 12px 8px;
        cursor: pointer;

        &:not(:first-child) {
          border-top: 1px solid
            ${({ theme }) => theme.colors.primaryRulerTint15};
        }

        &:last-child {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }

        &.select__option--is-focused {
          background-color: ${({ theme }) =>
            theme.colors.primaryBackgroundLight};
          color: ${({ theme }) => theme.colors.primaryText};
          ${({ theme }) => theme.fontStyles.InterfaceCopyBold}
        }

        &.select__option--is-selected {
          background-color: ${({ theme }) =>
            theme.colors.primaryBackgroundSelected};
          color: ${({ theme }) => theme.colors.neutralsWhite};
        }
      }
    }
  }

  > span.error {
    display: block;
    height: 12px;
    ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
    color: ${({ theme }) => theme.colors.offTrackText};
    padding-top: 4px;
  }
`;

export const Label = styled.label`
  left: 8px;
  pointer-events: none;
  position: absolute;
  transition: 0.4s ease all;
  color: ${({ theme }) => theme.colors.neutralsTextLight};
  top: ${({ $isFloating }) => ($isFloating ? `4px` : `12px`)};
  font-size: ${({ $isFloating }) => ($isFloating ? `10px` : `14px`)};
  line-height: ${({ $isFloating }) => ($isFloating ? `10px` : `14px`)};
  margin: 0;
  display: block;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  z-index: 1;
`;
